import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import CustomIcon from '../../CustomIcon';
import { Icons } from '../../../../Themes';

function EventUrl({ post }: any) {
  if (!post.event_url) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 1,
        mt: 1,
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <CustomIcon src={Icons.misc.accessPoint} size={24} />
      </Box>
      <Typography variant="body2" color="textSecondary" sx={{ fontWeight: 'fontWeightMedium' }}>
        <FormattedMessage id="POSTS.DETAILS.EVENT.EVENT_URL" />
      </Typography>
    </Box>
  );
}

export default EventUrl;
